import { DeliveryStatus } from "../delivery/Delivery"
import { Delivery } from "../delivery/Delivery"
import { JobSummary } from "../service/job-summary"
import { Todo } from "../todo/Todo"

export interface CalendarBetweenDatesResponse {
  jobs: JobSummary[]
  deliveries: Delivery[]
  todos: Todo[]
}

export type CalendarCountsResponse = Record<string, number>

export interface CalendarDayAggregate {
  jobSize: number
  todoSize: number
  price: number
  /** Summed estimated minutes of work of the day's jobs. */
  estimatedWorkMinutes: number
}

export type CalendarAggregatesResponse = Record<string, CalendarDayAggregate>

export type CalendarItemType = "job" | "todo" | "delivery"

export interface CalendarJobItem {
  type: "job"
  data: JobSummary
  id: string
  priority: number
  date: Date
}

export interface CalendarTodoItem {
  type: "todo"
  data: Todo
  id: string
  priority: number
  date: Date
}

export interface CalendarDeliveryItem {
  type: "delivery"
  data: Delivery
  id: string
  priority: number
  date: Date
}

export type CalendarItem =
  | CalendarJobItem
  | CalendarTodoItem
  | CalendarDeliveryItem

export function jobToCalendarItem(job: JobSummary): CalendarJobItem {
  return {
    type: "job",
    data: job,
    id: job.id,
    priority: job.priority,
    date: job.handInDate,
  }
}

export function todoToCalendarItem(todo: Todo): CalendarTodoItem | null {
  if (!todo.deadline) {
    return null
  }
  return {
    type: "todo",
    data: todo,
    id: todo.id,
    priority: todo.priority,
    date: todo.deadline,
  }
}

export function deliveryToCalendarItem(
  delivery: Delivery,
): CalendarDeliveryItem | null {
  let date: Date | undefined

  if (delivery.status === DeliveryStatus.TODO) {
    date = delivery.deadlineToOrderAt
  } else {
    date = delivery.expectedDeliveryAt
  }

  if (!date) {
    return null
  }

  return {
    type: "delivery",
    data: delivery,
    id: delivery.id,
    priority: delivery.priority,
    date,
  }
}
